export default {
  deviceSettings: {
    branchId: 'ID filiale',
    companyKey: 'Chiave azienda',
    deviceId: 'ID dispositivo',
    headingRegister: 'Registra dispositivo',
    headingUpdate: 'Cambia il codice di accesso alle impostazioni',
    invalidDeviceReference: 'Il tuo dispositivo potrebbe essere stato disabilitato dal tuo amministratore.',
    passcode: 'Passacodice',
    pleaseWaitRegister: 'Attendere mentre registriamo il tuo dispositivo',
    pleaseWaitUpdate: 'Attendere mentre aggiorniamo il tuo dispositivo',
    registrationFailed: 'Registrazione del dispositivo non riuscita',
    settingsPasscode: 'Impostazioni del passacodice',
    newSettingsPasscode: 'Not Implemented.',
    // TODO: Translate (PWA)
    settingsPasscodeConfirm: 'Confermare impostazioni del passacodice',
    successRegister: 'Il tuo dispositivo è stato registrato con successo!',
    successUpdate: 'Il tuo dispositivo è stato aggiornato con successo!',
    updateFailed: 'Aggiornamento del dispositivo non riuscio'
  }
};